import script from "./WordReport.vue?vue&type=script&setup=true&lang=js"
export * from "./WordReport.vue?vue&type=script&setup=true&lang=js"

import "./WordReport.vue?vue&type=style&index=0&id=77177d2c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77177d2c"]])

export default __exports__